import { useState } from 'react';
import { testimonials } from '../../../mocks/portfolio';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="text-[#2563EB] text-xs sm:text-sm font-bold uppercase tracking-wider mb-4 sm:mb-5 md:mb-6">
              • CLIENT REVIEWS
            </div>
            <div className="mb-6 md:mb-8">
              <i className="ri-double-quotes-l text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#2563EB] mb-4 sm:mb-5 md:mb-6 block"></i>
              <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-900 leading-relaxed mb-5 sm:mb-6 md:mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
                {testimonials[activeIndex].text}
              </p>
              <div className="flex items-center gap-4 mb-4">
                <div>
                  <div className="text-base sm:text-lg md:text-xl font-bold text-gray-900">
                    — {testimonials[activeIndex].name}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600">
                    {testimonials[activeIndex].project}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-base sm:text-lg md:text-xl text-yellow-400"></i>
                  ))}
                </div>
                <span className="text-xs sm:text-sm text-gray-600 ml-2">Google Review</span>
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex gap-3">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === activeIndex ? 'bg-[#2563EB] w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2 relative h-[350px] sm:h-[450px] md:h-[550px] lg:h-[600px] rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/6c9486c5bf35e716937ff3d49fffe78c.jpg"
              alt="Happy Client"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}